export enum PSD_CALC_MODE {
  PERCENT = 'PERCENT',
  MASS = 'MASS',
}
